import { Dimensions, Platform, StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  modalStyle: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColor,
    margin: 0,
  }),
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    margin: 16.6,
    marginBottom: 51,
  },
  headerWithoutTitle: { justifyContent: 'space-between', alignItems: 'center' },
  container: theme => ({
    padding: 16.6,
    backgroundColor: theme.colors.backgroundColor,
  }),
  button: { marginBottom: 20 },
  lastButton: { marginBottom: 60 },
  sectionTitle: {
    fontSize: 25,
    lineHeight: 31.2,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 33,
    ...Fonts.type.bold,
  },
  sectionTitleSml: { fontSize: 20, marginBottom: 16 },
  sectionActionsContainer: {
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 33
  },
  checkItemContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginHorizontal: 5,
    marginVertical: 12.6,
  },
  checkItemIcon: { marginEnd: 22 },
  checkItemTitle: { flex: 1, fontSize: 16.6, lineHeight: 22.9 },
  toggleContainer: isLast => ({
    marginEnd: 0,
    ...(isLast && { borderBottomWidth: 0 }),
  }),
  toggleDiscription: { marginEnd: 0 },
  lottieStyle: { width: 200, height: 200 },
  readPrivacy: theme => ({
    color: theme.colors.textColorTen,
    fontSize: 16,
    marginBottom: 40,
    alignSelf: 'center',
    textDecorationLine: 'underline',
  }),
  headerTitle: { fontSize: 18 },
  contentContainer: { minHeight: '100%', paddingBottom: 80 },
  successContainer: { minHeight: '100%', paddingBottom: 33 },
  titleStyle: { fontSize: 24 },
  descriptionStyle: { fontSize: 16, marginHorizontal: 32 },
  rejectAllModalTextContainer: { flexGrow: 1, justifyContent: 'center' },
  fullPage: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100%',
  },
  processingLottie: { width: 200, height: 200 },
  processingText: { fontSize: 16, lineHeight: 22 },
  successTextContainer: { flexGrow: 1, justifyContent: 'center' },
});
